import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.home');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-home',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.home/view.scss */
:host {
  display: block;
  height: 100%;
}`],
})
export class PageHomeComponent implements OnInit {

  public role: string | null = null;
  public ready = false;

  constructor(@Inject( Service) public service: Service) {}

  async ngOnInit() {
    await this.service.init();
    const allowed = await this.service.auth.allow(true, "/auth/login");
    if (!allowed) return;

    const authSession = this.service.auth?.session ?? {};
    this.role = (authSession.role ?? '').toString().toLowerCase() || null;
    this.ready = true;

    await this.service.render();
  }
}

export default PageHomeComponent;